<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    size="lg"
    no-close-on-backdrop
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <table class="table">
        <tr class="bg-blue-grey bg-lighten-5">
          <th style="width: 25%">Cep inicio</th>
          <th style="width: 25%">Cep Fim</th>
          <th style="width: 40%">
            <b-spinner
              v-if="loadingCep"
              small
              label="Small Spinner"
            ></b-spinner>
            Municipio
          </th>
          <th style="width: 10%">Ações</th>
        </tr>
        <tbody v-for="(row, index) in faixa">
          <tr style="display: table-row">
            <td class="p-0">
              <b-form-input
                type="text"
                placeholder="Cep Inicio"
                v-model="row.cep_ini"
                :name="'cep_ini' + index"
                v-mask="'#####-###'"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('faixa.' + index + '.cep_ini')"
                v-if="form.errors.has('faixa.' + index + '.cep_ini')"
              ></b-form-feedback>
            </td>
            <td class="p-0">
              <b-form-input
                type="text"
                placeholder="Cep Fim"
                v-model="row.cep_fim"
                :name="'cep_fim' + index"
                v-mask="'#####-###'"
                @keyup="getMunicipio(row, index)"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('faixa.' + index + '.cep_fim')"
                v-if="form.errors.has('faixa.' + index + '.cep_fim')"
              ></b-form-feedback>
            </td>
            <td class="p-0">
              <b-form-input
                type="text"
                placeholder="Municipio"
                v-model="row.municipio_nome"
                name="municipio_nome"
                disabled
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('faixa.' + index + '.municipio_id')"
                v-if="form.errors.has('faixa.' + index + '.municipio_id')"
              ></b-form-feedback>
            </td>
            <td>
              <i
                class="fa fa-times"
                style="cursor: pointer; margin-left: 50%"
                v-b-tooltip.hover.right="'Remover Faixa de CEP'"
                v-on:click="removeRowFaixa(index)"
              ></i>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table">
        <tbody>
          <tr class="table-info" style="display: table-row">
            <td colspan="4" style="width: 90%"></td>
            <td class="text-right" style="width: 90%">
              <i
                class="fa fa-plus-square"
                v-on:click="addRowFaixa($event)"
                v-b-tooltip.hover.right="'Adicionar Faixa'"
                style="cursor: pointer"
              ></i>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="secondary"
          :disabled="isDisabled"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";

export default {
  components: {
    AvisoErros,
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  data() {
    return {
      dataExport: [],
      faixa: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loadingCep: false,
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      statusSelected: [],
      ufSelected: [],
      optionsLivStatus: [],
      optionsUf: [],
      errors_array: [],
      form: new Form({
        faixa: [],
        regiao_id: "",
        regcep_id: "",
      }),
      helpForm: new Form({
        statusRecord: [],
        params: [],
        cep_ini: "",
        cep_fim: "",
      }),
      fields: [],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.reguf_id);
      }
    },
    onCreate(id, data) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Vincular Faixas CEP";
      this.modal_botao = "Vincular Faixas CEP";
      this.modal_acao = "i";
      this.form.reset();
      this.faixa = [];
      this.errors_array = "";
      this.errors_array = [];
      this.form.regiao_id = id;
      if (data.regiao_cep.length > 0) {
        data.regiao_cep.forEach((obj) => {
          if (obj.status.valor == 1) {
            this.faixa.push({
              regcep_id: obj.regcep_id,
              cep_ini: obj.cep_ini,
              cep_fim: obj.cep_fim,
              municipio_nome: obj.municipio.nome,
              municipio_id: obj.municipio_id,
              status: obj.status.valor,
            });
          }
        });
      }
      this.$refs.modal_form.show();
    },
    onEdit(data) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.errors_array = "";
      this.errors_array = [];
      this.form.reset();
      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      if (this.faixa.length > 0) {
        this.faixa.forEach((obj) => {
          obj.cep_ini = obj.cep_ini.replace("-", "");
          obj.cep_fim = obj.cep_fim.replace("-", "");
        });
      }

      this.form.faixa = this.faixa;
      this.form
        .patch("/api/regiaocep/update")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .patch("/api/" + this.rota + "/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/regiaocep/status")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    addRowFaixa: function (e) {
      e.preventDefault();
      this.faixa.push({
        regcep_id: "",
        cep_ini: "",
        cep_fim: "",
        municipio_id: "",
        municipio_nome: "",
        status: 1,
      });
    },
    removeRowFaixa: function (index) {
      this.faixa.splice(index, 1);
    },
    getMunicipio(data, index) {
      if (data.cep_fim.length == 9) {
        this.loadingCep = true;
        this.isDisabled = true;
        this.helpForm.cep_ini = data.cep_ini.replace("-", "");
        this.helpForm.cep_fim = data.cep_fim.replace("-", "");
        this.helpForm
          .post("/api/regiaocep/buscar")
          .then((response) => {
            new ReturnApi(response, this);
            this.faixa[index].municipio_nome =
              response.municipio.municipio.nome;
            this.faixa[index].municipio_id = response.municipio.municipio_id;
            this.loadingCep = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = "";
            this.errors_array = [];
            this.loadingCep = false;
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof errors[property] === "object") {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj,
                    });
                  });
                }
              }
            }
          });
      }
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
